import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import { DataTable } from '../../../../../design/dataTable/DataTable';
import { IAdminPageProperties } from '../../../IAdminPageProperties';
import { UserAdminDomain } from './store/UserAdminDomain';

export interface UserAdminTableProperties extends IAdminPageProperties { }

export const UserAdminTable = observer(({ layoutDomain }: UserAdminTableProperties) => {
  useEffect(() => {
    layoutDomain.ui.pagePadding.setValue(0)
    return () => layoutDomain.ui.pagePadding.setValue(24)
  }, [])
  const [domain] = useState<UserAdminDomain>(new UserAdminDomain(layoutDomain));

  return <DataTable dataTableDomain={domain} tableHeight={window.innerHeight} />;
});
